import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class FumbleStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            (fragment.associatedState === FootballState.Fumble ||
                fragment.associatedState === FootballState.FieldGoalFumble) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { forcedBy } = fragment;
        const possessionPlayer = gameContext.getCurrentPlayerInPossession();
        const stats = [];
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: possessionPlayer.teamId,
                playerId: possessionPlayer.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.FUMBLE,
                values: { completed: 1 }
            },
            stats
        );

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: forcedBy.teamId,
                playerId: forcedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.FUMBLE_FORCED,
                values: { completed: 1 }
            },
            stats
        );

        return stats;
    }
}
